const STORAGE_KEY = 'labnet-sidebar';
const DESKTOP_MQ = '(min-width: 768px)';

/**
 * @returns {'collapsed'|'expanded'}
 */
function getPreferredSidebar() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'collapsed' || saved === 'expanded') {
        return saved;
    }

    return 'expanded';
}

/**
 * @returns {boolean}
 */
function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
}

/**
 * @param {'collapsed'|'expanded'} mode
 */
function setSidebar(mode) {
    document.documentElement.setAttribute('data-sidebar', mode);
    localStorage.setItem(STORAGE_KEY, mode);
    updateToggleButtons(mode);
    document.dispatchEvent(new CustomEvent('sidebar-changed', { detail: { mode } }));
}

function toggleSidebar() {
    if (!isDesktop()) {
        return;
    }

    const current = document.documentElement.getAttribute('data-sidebar') || getPreferredSidebar();
    setSidebar(current === 'collapsed' ? 'expanded' : 'collapsed');
}

/**
 * @param {'collapsed'|'expanded'} mode
 */
function updateToggleButtons(mode) {
    document.querySelectorAll('[data-sidebar-toggle]').forEach((button) => {
        const iconCollapse = button.querySelector('.sidebar-toggle-icon--collapse');
        const iconExpand = button.querySelector('.sidebar-toggle-icon--expand');

        if (iconCollapse) {
            iconCollapse.classList.toggle('d-none', mode === 'collapsed');
        }

        if (iconExpand) {
            iconExpand.classList.toggle('d-none', mode !== 'collapsed');
        }

        const label = mode === 'collapsed'
            ? button.dataset.labelExpand
            : button.dataset.labelCollapse;

        if (label) {
            button.setAttribute('title', label);
            button.setAttribute('aria-label', label);
            button.setAttribute('aria-expanded', mode === 'expanded' ? 'true' : 'false');
        }
    });
}

function initSidebarManager() {
    const currentMode = document.documentElement.getAttribute('data-sidebar') || getPreferredSidebar();
    updateToggleButtons(currentMode);

    document.querySelectorAll('[data-sidebar-toggle]').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            toggleSidebar();
        });
    });
}

module.exports = {
    STORAGE_KEY,
    getPreferredSidebar,
    setSidebar,
    toggleSidebar,
    initSidebarManager,
};
